// Model
import { componentsInspectionlessV11Names } from './components.enum';
import { RoomRulesDesign } from '../../../components/models/component-options/inline-rules.options';
import { TabSectionMode } from '../../../components/models/component-options/tabs-section.options';
import { RMCEventType } from '../../../components/common/resource-media-control/model/resource-media-control.event';
import { CaptureType } from '../../../components/common/panorama-tour/model/report-image.model';
import { FormModelType } from '../../../components/common/resource-media-control/model/resource-media.model';
// Component
import { RoomLayoutComponent } from '../../../components/common/room-layout/room-layout.component';
import { TabsSectionComponent } from '../../../components/common/tabs-section/tabs-section.component';
import { InlineRulesComponent } from '../../../components/common/inline-rules/inline-rules.component';
import { MapLocationComponent } from '../../../components/common/map-location/map-location.component';
import { PanoramaTourComponent } from '../../../components/common/panorama-tour/panorama-tour.component';
import { PhotoGalleryComponent } from '../../../components/common/photo-gallery/photo-gallery.component';
import { PhotoListSelectedComponent } from '../../../components/common/photo-list-selected/photo-list-selected.component';
import { PhotoListBulkDeleteComponent } from '../../../components/common/photo-list-bulk-delete/photo-list-bulk-delete.component';
import { ResourceMediaControlComponent } from '../../../components/common/resource-media-control/resource-media-control.component';
import { SmartTagsComponent } from '../../../components/common/smart-tags/smart-tags.component';
import { DynamicHtmlComponent } from '../../../components/common/dynamic-html/dynamic-html.component';
import { SingleImageComponent } from '../../../components/common/single-image/single-image.component';
import { GeneralPropertyDataComponent } from '../../../components/schema/v40/general-property-data/general-property-data.component';
import { GeneralOrderDataComponent } from '../../../components/schema/v40/general-order-data/general-order-data.component';
import { TabsSectionButtonComponent } from '../../../components/common/tabs-action-button/tabs-section-button.component';
import { DynamicFieldsSectionComponent } from '../../../components/common/dynamic-fields-section/dynamic-fields-section.component';

export const layoutInspectionless11Components = {
	[componentsInspectionlessV11Names.ROOM_LAYOUT]: RoomLayoutComponent,
	[componentsInspectionlessV11Names.TABS_SECTION]: TabsSectionComponent,
	[componentsInspectionlessV11Names.HTML_NODE]: DynamicHtmlComponent,
	[componentsInspectionlessV11Names.FIELDS_SECTION]: DynamicFieldsSectionComponent,
	[componentsInspectionlessV11Names.MAP]: MapLocationComponent,
	[componentsInspectionlessV11Names.RULES]: InlineRulesComponent,
	[componentsInspectionlessV11Names.PANORAMA_TOUR]: PanoramaTourComponent,
	[componentsInspectionlessV11Names.RESOURCE_MEDIA]: ResourceMediaControlComponent,
	[componentsInspectionlessV11Names.PHOTO_GALLERY]: PhotoGalleryComponent,
	[componentsInspectionlessV11Names.PHOTO_SELECTED]: PhotoListSelectedComponent,
	[componentsInspectionlessV11Names.PHOTO_BULK_DELETE]: PhotoListBulkDeleteComponent,
	[componentsInspectionlessV11Names.SMARTTAGS_LIST]: SmartTagsComponent,
	[componentsInspectionlessV11Names.SINGLE_IMAGE]: SingleImageComponent,
	[componentsInspectionlessV11Names.PROPERTY_DATA]: GeneralPropertyDataComponent,
	[componentsInspectionlessV11Names.GENERAL_ORDER_DATA]: GeneralOrderDataComponent,
	[componentsInspectionlessV11Names.TABS_SECTION_BUTTON]: TabsSectionButtonComponent
};

export const layoutInspectionless11 = {
	// generalOrderData: {
	// 	type: componentsInspectionlessV11Names.ROOM_LAYOUT,
	// 	options: {
	// 		schemaVersion: 'v40',
	// 		bodyCssClass: 'px-0',
	// 		header: {
	// 			value: 'General Order Data'
	// 		}
	// 	},
	// 	items: [
	// 		{
	// 			type: componentsInspectionlessV11Names.GENERAL_ORDER_DATA,
	// 			options: {
	// 				cssClass: 'h-100',
	// 				outerCssClass: 'col has-borders border-left'
	// 			}
	// 		}
	// 	]
	// },
	propertyData: {
		type: componentsInspectionlessV11Names.ROOM_LAYOUT,
		options: {
			schemaVersion: 'v40',
			bodyCssClass: 'px-0',
			header: {
				value: 'Property Data'
			}
		},
		items: [
			{
				type: componentsInspectionlessV11Names.RULES,
				options: {
					cssClass: 'h-100',
					outerCssClass: 'col-md-3 has-borders border-left',
					layout: RoomRulesDesign.FULL_WIDTH,
					appendPathToTarget: false,
					filter: (violation: any, path: string) => {
						return (violation.targets && violation.targets.length === 0)
							|| violation.uiSection === 'PROPERTY_GENERAL_DATA';
					}
				}
			},
			{
				type: componentsInspectionlessV11Names.PROPERTY_DATA,
				options: {
					cssClass: 'h-100',
					outerCssClass: 'col has-borders border-left',
					hideFields: [
						'InspectionReport.property.propertyAnalysis.propertyTaxSpecialAmount',
						'InspectionReport.property.propertyAnalysis.propertyTaxSpecialDescription'
					]
				}
			}
		]
	},
	// map: {
	// 	type: componentsInspectionlessV11Names.ROOM_LAYOUT,
	// 	options: {
	// 		schemaVersion: 'v40',
	// 		bodyCssClass: 'container-map px-0',
	// 		header: {
	// 			value: 'Location'
	// 		}
	// 	},
	// 	items: [
	// 		{
	// 			type: componentsInspectionlessV11Names.MAP,
	// 			options: {
	// 				layout: 'v2',
	// 				outerCssClass: 'px-0',
	// 				filterSmartTagOptions: {
	// 					key: 'groupName',
	// 					value: 'location'
	// 				}
	// 			}
	// 		}
	// 	]
	// },
	generalSmartTags: {
		type: componentsInspectionlessV11Names.ROOM_LAYOUT,
		options: {
			schemaVersion: 'v40',
			cssClass: 'natural-height',
			bodyCssClass: 'px-0',
			header: {
				value: 'Property Smart Tags'
			}
		},
		items: [
			{
				type: componentsInspectionlessV11Names.RULES,
				options: {
					cssClass: 'h-100',
					outerCssClass: 'col-md-3 has-borders border-left',
					layout: RoomRulesDesign.FULL_WIDTH // @see RoomRulesDesign
				}
			},
			{
				type: componentsInspectionlessV11Names.HTML_NODE,
				options: {
					outerCssClass: 'col has-borders',
					cssClass: 'row'
				},
				items: [
					{
						type: componentsInspectionlessV11Names.RESOURCE_MEDIA,
						options: {
							layout: 'v2',
							groupKey: 'groupName',
							outerCssClass: 'resource-media-control'
						}
					},
					{
						type: componentsInspectionlessV11Names.TABS_SECTION,
						options: {
							outerCssClass: 'col-md-7 has-borders border-left border-right',
							tabActionButtons: true
						},
						items: [
							{
								title: 'Selected Photos',
								type: componentsInspectionlessV11Names.PHOTO_SELECTED
							},
							{
								title: 'Upload Image',
								type: componentsInspectionlessV11Names.TABS_SECTION_BUTTON,
								options: {
									tabSectionMode: TabSectionMode.DROPDOWN,
									dropdownOptions: [
										{
											label: 'Smart Tags',
											icon: 'fa-tag',
											data: {
												eventType: RMCEventType.OPEN,
												componentData: {
													resourceMediaModel: {
														captureType: CaptureType.SMARTTAG,
														formModelType: FormModelType.CREATE,
														snapshot: {
															preview: false,
															metadata: {}
														}
													}
												}
											}
										},
										{
											label: 'Imageless Smart Tag',
											icon: 'fa-tag',
											data: {
												eventType: RMCEventType.OPEN,
												componentData: {
													resourceMediaModel: {
														isImageless: true,
														captureType: CaptureType.SMARTTAG,
														formModelType: FormModelType.CREATE,
														snapshot: {
															preview: false,
															metadata: {}
														}
													}
												}
											}
										}
									]
								}
							}
						]
					},
					{
						type: componentsInspectionlessV11Names.SMARTTAGS_LIST,
						options: {
							outerCssClass: 'col-md-5 has-borders border-right',
							key: 'smartTags',
							groupKey: 'groupName',
							version: 'v2',
							exclude: ['location', 'LOCATION']
						}
					}
				]
			}
		]
	}
};
